import styled from 'styled-components';

const green = '#47b972';

export const Content = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  overflow: auto;
  background: radial-gradient(ellipse 60% 55% at 50% 42%, #18291f 0%, #0d1612 55%, #0a100d 100%);
  color: #e6eaec;
`;

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 290px;
  max-width: 100%;
  margin: auto;
  padding: 21px 16px;
  box-sizing: border-box;
`;

export const Logo = styled.svg`
  display: block;
  overflow: visible;
  /* запас сверху под поднятую стрелу шлагбаума */
  margin-top: 78px;
  margin-bottom: 26px;
`;

export const Pill = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 5px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const PillOption = styled.button`
  appearance: none;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 5px 16px;
  border-radius: 999px;
  font: inherit;
  font-size: 16px;
  line-height: 1.2;
  white-space: nowrap;
  color: #9aa4a9;
  background: transparent;
  transition: background 0.15s, color 0.15s;
  &:hover {
    color: #e6eaec;
  }
  &.active {
    cursor: default;
    color: #0c1a12;
    background: ${green};
  }
`;

export const LangPill = styled(Pill)`
  margin-bottom: 23px;
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const InputWrap = styled.div`
  position: relative;
  margin-bottom: 16px;

  input {
    width: 100%;
    height: 44px;
    box-sizing: border-box;
    padding: 0 44px 0 16px;
    border: 1px solid transparent;
    border-radius: 9px;
    outline: none;
    background: #e9edf7;
    color: #151b21;
    font: inherit;
    font-size: 18px;
  }
  input::placeholder {
    color: #7b8791;
  }
  input:focus {
    border-color: ${green};
  }
  &.error input {
    border-color: #cc2936;
  }
`;

export const Eye = styled.button`
  position: absolute;
  top: 0;
  right: 3px;
  height: 44px;
  width: 39px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: #5d6a73;
  cursor: pointer;
  &:hover {
    color: #151b21;
  }
`;

export const FieldError = styled.div`
  position: absolute;
  left: 5px;
  bottom: -14px;
  font-size: 10px;
  color: #ff7580;
`;

export const Submit = styled.button`
  height: 44px;
  margin-top: 5px;
  border: none;
  border-radius: 9px;
  background: ${green};
  color: #0c1a12;
  font: inherit;
  font-size: 18px;
  cursor: pointer;
  transition: filter 0.15s;
  &:hover:not(:disabled) {
    filter: brightness(1.08);
  }
  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

export const ApiError = styled.div`
  margin-top: 10px;
  text-align: center;
  font-size: 16px;
  color: #ff7580;
`;

export const Divider = styled.hr`
  width: 100%;
  margin: 21px 0 16px;
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

export const ViewRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #8a959b;
  font-size: 16px;
`;

export const ViewPill = styled(Pill)`
  ${PillOption} {
    font-size: 14px;
    padding: 4px 13px;
  }
`;
